var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LongTimeField"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"value",on:{"click":_vm.onConfirm}},[(_vm.switchOn)?_c('img',{attrs:{"src":require("@/assets/style/switch-open.png"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/style/switch-on.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }